import * as React from "react";
import { cn } from "@/lib/utils";

interface BackdropProps {
  open: boolean;
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
}

function Backdrop({ open, onClick, className, children }: BackdropProps) {
  if (!open) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-(--z-modal) flex flex-col items-center justify-center bg-foreground/50 text-white",
        className,
      )}
      onClick={onClick}
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
}

export { Backdrop };
